export default __webpack_public_path__ + "static/media/t4u-web_converted.c7ab55c6.jpg";